export const truncateDescription = (description: string, maxLength = 70) => {
    if (description.length > maxLength) {
      return description.slice(0, maxLength) + "...";
    }
    return description;
  };